import { useState, useCallback } from 'react';
import { useFetch } from './useFetch';

export const useGroupOfPeople = () => {

  const {
    data,
    loading,
    links,
    currentPage,
    fetchData,
  } = useFetch({
    isPagination: true,
    initialData: [],
  });

  const [searchText, setSearchText] = useState("");

  const fetchDataGroupOfPeople = useCallback((paginate = false) => {
    if (paginate)
      fetchData(`/peoplegroups?search=${searchText}&paginate=10`, paginate);
    else
      fetchData(`/peoplegroups?search=${searchText}`, false);
  }, [searchText]);


  return {
    data,
    loading,
    setSearchText,
    searchText,
    fetchData: fetchDataGroupOfPeople,
    links,
    currentPage,
  };
};
